export default "__VITE_ASSET__zRx7W$o7__"